import { ProductSettingTypes } from 'constants/enums/productTypes'
import { IFooter } from 'interfaces/i-footer'

export const footerValues: IFooter[] = [
	/* Always keep 'en' value first */
	{
		country: 'en',
		copyRight: 'TF Bank Nordic AB',
		links: {
			about: {
				title: 'AboutUs',
				link: 'https://www.tfbank.se/om-tf-bank/',
			},
		},
		address: {
			companyName: 'TF Bank AB',
			addressLine1: 'Box 947',
			zipCodeAndCity: '501 10, Borås',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'info@tfbank.se',
				},
			},
		],
	},
	{
		country: 'de',
		copyRight:
			'TF Bank (ein zweiter Firmenname von Avarda Bank AB (publ)) reg. no. 556158-1041, Schweden',
		address: {
			companyName: 'TF Bank',
			addressLine1: 'Postfach 11 02 28',
			zipCodeAndCity: '10832 Berlin',
		},
		links: {
			about: {
				title: 'AboutUs',
				link: 'https://tfbank.de/uber-uns',
			},
			cookie: {
				title: 'Cookies',
				link: 'https://tfbank.de/cookies',
			},
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'ratenkredit@tfbank.de',
					phoneNumber: '+49 30 46690200',
				},
			},
		],
	},
	{
		country: 'dk',
		copyRight: 'TF Bank Nordic AB',
		links: {
			about: {
				title: 'AboutUs',
				link: 'https://tfbank.dk/om-tf-bank',
			},
		},
		address: {
			companyName: 'TF Bank Nordic AB',
			addressLine1: 'Box 947',
			zipCodeAndCity: '501 10, Borås',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'info@tfbank.dk',
					phoneNumber: '78 73 04 60',
				},
			},
		],
	},
	{
		country: 'es',
		copyRight:
			'TF Bank (a secondary business name of Avarda Bank AB (publ), reg. no. 556158-1041)',
		links: {
			about: {
				title: 'AboutUs',
				link: 'https://tfbank.es/sobre-tf-bank',
			},
		},
		address: {
			companyName: 'TF Bank',
			addressLine1: 'Box 947',
			zipCodeAndCity: '501 10, Borås',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'hola@tfbank.es',
					phoneNumber: '91 993 10 15',
				},
			},
		],
	},
	{
		country: 'fi',
		copyRight: 'TF Bank Nordic AB, Suomen sivuliike',
		links: {
			about: {
				title: 'AboutUs',
				link: 'https://www.tfbank.fi/tietoa-tf-bankista/',
			},
		},
		address: {
			companyName: 'TF Bank Nordic AB, Suomen sivuliike',
			businessId: 'Y-tunnus 3529515-2',
			addressLine1: 'PL 5600',
			zipCodeAndCity: '00002, Helsinki',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'info@tfbank.fi',
					phoneNumber: '0206 90681',
				},
			},
		],
	},
	{
		country: 'no',
		copyRight: 'TF Bank Nordic AB NUF',
		copyRight2: 'Avarda Bank AB NUF',

		links: {
			cookie: {
				title: 'Cookies',
				link: 'https://www.tfbank.no/personvernerklaring/',
			},
			faq: {
				title: 'FAQ',
				link: 'https://tfbank.no/hjelp',
			},
		},
		address: {
			companyName: 'TF Bank Nordic AB NUF',
			addressLine1: 'Postboks 956 Sentrum',
			zipCodeAndCity: '5808, Bergen',
		},
		address2: {
			companyName: 'Avarda Bank AB NUF',
			addressLine1: 'Postboks 956 Sentrum',
			zipCodeAndCity: '5808, Bergen',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.Card,
				contactInformation: {
					email: 'kort@tfbank.no',
					phoneNumber: '56 99 92 00',
					openingHours: '09:00 - 18:00',
				},
			},
			{
				productType: ProductSettingTypes.Loan,
				contactInformation: {
					email: 'post@tfbank.no',
					phoneNumber: '53 00 53 99',
				},
			},
		],
	},
	{
		country: 'se',
		copyRight: 'TF Bank Nordic AB',
		links: {
			cookie: {
				title: 'AboutUs',
				link: 'https://www.tfbank.se/om-tf-bank/',
			},
			faq: {
				title: 'Cookies',
				link: 'https://tfbank.se/om-tf-bank/cookies-och-sakerhet',
			},
		},
		address: {
			companyName: 'TF Bank Nordic AB',
			addressLine1: 'Box 947',
			zipCodeAndCity: '501 10, Borås',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'info@tfbank.se',
					phoneNumber: '033-722 35 10',
				},
			},
		],
	},
	{
		country: 'lt',
		copyRight: 'TF Bank AB',
		links: {
			about: {
				title: 'AboutUs',
				link: 'https://tfbank.lt/apie-tf-bank-ab',
			},
			forms: {
				title: 'Forms',
				link: 'https://tfbank.lt/prasymu-formos',
			},
			financialDifficulties: {
				title: 'FinancialDifficulties',
				link: 'https://tfbank.lt/susidurus-su-finansiniais-sunkumais',
			},
			consumerLoan: {
				title: 'ConsumerLoan',
				link: 'https://tfbank.lt/vartojimo-paskola',
			},
			cookie: {
				title: 'Cookies',
				link: 'https://tfbank.lt/slapukai',
			},
		},
		address: {
			companyName: 'TF Bank Lietuvos filialas',
			addressLine1: 'Lvivo g. 25',
			zipCodeAndCity: 'LT-09320, Vilnius',
		},
		productSpecific: [
			{
				productType: ProductSettingTypes.All,
				contactInformation: {
					email: 'info@tfbank.lt',
					phoneNumber: '1899',
				},
			},
		],
	},
]
